import React from "react";
import IconReject from "./IconWizardReject";
import IconSuccess from "./IconWizardSuccess";
import IconOngoing from "./IconWizardOngoing";
import IconTimeSensitive from "../../iconComponents/IconTimeSensitive";

export default function WizardStep(props) {

    const stepIcon = () => {
        switch (props.display) {
            case "success": return <IconSuccess height="24px" pathClass="w-fill"/>
            case "ongoing": return <IconOngoing height="24px" pathClass="w-fill"/>
            case "rejected": return <IconReject height="24px" pathClass="tb-fill"/>
            default: return <></>
        }
    }
    const color = () => {
        switch (props.display) {
            case "success": return "#245EF5"
            case "ongoing": return "url(#_Linear1)"
            case "schedule": return "#919197"
            default: return "white"
        }
    }

    const describeRemaining = props.remaining === 0 ? "Due Today" : `${props.remaining} Days`
                        
    return (
        <div style={{flex: 1, marginLeft: "-8px", position: "relative"}}>
            <svg 
                width="100%" 
                height="24" 
                fill={color()}
                stroke={ props.display === "success" ? "#245EF5" : "#919197"}
                strokeWidth="1.5"
            >
                <rect 
                    x="15px" 
                    y="0" 
                    width="calc(100% - 15px)" 
                    height="100%" 
                    transform="skewX(-30)" 
                />
                { props.display === "ongoing"  &&
                <defs>
                    <linearGradient id="_Linear1" x1="0" x2="1" y1="0" y2="0" >
                        <stop offset="0" stopColor="#245EF5"></stop>
                        {/* <stop offset="0" stopColor="#CACFFC"></stop> */}
                        <stop offset="0.2" stopColor="#98C1FF"></stop>
                        <stop offset="0.9" stopColor="#fff"></stop>
                    </linearGradient>
                </defs>
                }
            </svg>
                { props.display !== "future" &&
                <div className="wizard-icon">
                    <div>
                        {stepIcon()}
                    </div>
                </div> }
            <div className="gap-above-xs">
                <h4 className="content1 light-black">{props.step}</h4>
                <h5 className="content3 light-black">{props.party_name}</h5>
                <h5 className="content3 light-black">{props.email}</h5>
                {props.date && <h5 className="content3 light-black">{props.date}</h5>}
                {props.date_due && <h5 className="content3 light-black">{props.date_due}</h5>}
                {props.date_done && <h5 className="content3 light-black">{props.date_done}</h5>}
                {(props.remaining !== undefined && props.remaining !== null) &&
                    <h5 className={`content2 heavy gap-above-xxs ${props.remaining < 1 ?"tb-text":"p-text"}`}>
                        <IconTimeSensitive 
                            svgClass="gap-right-xxs" 
                            svgStyle={{verticalAlign: "text-bottom", paddingBottom: '1px'}} 
                            width="16px" 
                            colorClass={props.remaining < 1 ? "tb-fill" : "p-fill"}
                        />
                        {describeRemaining}
                    </h5>
                }
            </div>
        </div>
    )
}


// linear-gradient(90deg, #98C1FF 0%, rgba(177, 184, 251, 0) 100%);